import React, { useState } from "react";
import { Tabs, Tab, Button } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import EditComplianceCampaign from "../../Components/EditComplianceCampaignModal/EditComplianceCampaign";
import CampaignSettings from "../../Components/CampaignSettingsModal/CampaignSettings";
import CampaignUsers from "../../Components/CampaignUsersModal/CampaignUsers";
import CampaignEmailLog from "../../Components/CampaignEmailLogModal/CampaignEmailLog";
import CampaignAssignment from "../../Pages/CampaignAssignment/CampaignAssignment";
const PoliceDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [key, setKey] = useState("details");

  return (
    <div className="p-4 mb-4">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "16px",
        }}
      >
        <div className="pageTitle">{t("EditTab")}</div>
        <Button variant="primary" onClick={() => navigate(-1)}>
          {t("Back")}
        </Button>
      </div>
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3"
      >
        <Tab eventKey="details" title={t("ComplianceCampaign")}>
          <EditComplianceCampaign id={id} />
        </Tab>

        <Tab eventKey="CampaignSettings" title={t("CampaignSettings")}>
          <CampaignSettings id={id} />
        </Tab>
        <Tab eventKey="CampaignUsers" title={t("CampaignUsers")}>
          <CampaignUsers id={id} />
        </Tab>
       
        <Tab eventKey="CampaignAssignment" title={t("CampaignAssignment")}>
          <CampaignAssignment id={id} />
        </Tab>
        <Tab eventKey="CampaignEmailLog" title={t("CampaignEmailLog")}>
          <CampaignEmailLog id={id} />
        </Tab>
      </Tabs>
    </div>
  );
};

export default PoliceDetail;
